export default "### Why is this disabled?\nIn order to use this feature, you must first [create a free account or login](/sign-up).";